module.exports = __webpack_public_path__ + "assets/img/76@3x.1ded31f4.png";